import { toNumber } from 'lodash'
import { Media } from '@node/wam-audience-builder'

export default {
    commitError: (commit, action, error) => {
        commit(
            action,
            {
                type: 'error',
                message: error.message
            },
            { root: true }
        )
        throw error
    },

    buildRoutes: accountId => {
        const conversionRoute = '/audience_admin/advertiser_conversions.json'
        const campaignRoute = '/audience_admin/advertiser_campaigns/tree_with_insertions_visible_in_wam.json'
        const conversionParams = {
            params: { list_limit: 0, account_id: accountId, conditions: { status: 'active' } }
        }
        const campaignParams = {
            params: {
                //list_limit: 0,
                account_id: accountId,
                conditions: { project: { status: 'active' }, campaign: { is_visible_in_wam: 'YES', status: 'active' } }
            }
        }
        return { conversionRoute, campaignRoute, conversionParams, campaignParams }
    },

    parseConversionData: (data, wcmAccountId) => {
        const _data = []
        for (const val of data) {
            const wamData = [
                {
                    id: [toNumber(wcmAccountId), toNumber(val.id)],
                    label: val.label,
                    isSelectable: true,
                    hasChild: true,
                    parentJsonKeyName: 'media_conversion',
                    jsonKey: {
                        name: 'wcm_conversion_' + wcmAccountId + '_' + val.id,
                        type: 'WcmConversion',
                        subType: 'conversion',
                        ids: [toNumber(wcmAccountId), toNumber(val.id)]
                    }
                },
                {
                    id: [toNumber(wcmAccountId), toNumber(val.id)],
                    label: 'Post-click ' + val.label,
                    isSelectable: true,
                    hasChild: false,
                    parentJsonKeyName: 'wcm_conversion_' + wcmAccountId + '_' + val.id,
                    jsonKey: {
                        name: 'wcm_post_click_conversion_' + wcmAccountId + '_' + val.id,
                        type: 'WcmPostClickConversion',
                        subType: 'conversion',
                        ids: [toNumber(wcmAccountId), toNumber(val.id)]
                    }
                },
                {
                    id: [toNumber(wcmAccountId), toNumber(val.id)],
                    label: 'Post-event ' + val.label,
                    isSelectable: true,
                    hasChild: false,
                    parentJsonKeyName: 'wcm_conversion_' + wcmAccountId + '_' + val.id,
                    jsonKey: {
                        name: 'wcm_post_event_conversion_' + wcmAccountId + '_' + val.id,
                        type: 'WcmPostEventConversion',
                        subType: 'conversion',
                        ids: [toNumber(wcmAccountId), toNumber(val.id)]
                    }
                },
                {
                    id: [toNumber(wcmAccountId), toNumber(val.id)],
                    label: 'Post-impression ' + val.label,
                    isSelectable: true,
                    hasChild: false,
                    parentJsonKeyName: 'wcm_conversion_' + wcmAccountId + '_' + val.id,
                    jsonKey: {
                        name: 'wcm_post_impression_conversion_' + wcmAccountId + '_' + val.id,
                        type: 'WcmPostImpressionConversion',
                        subType: 'conversion',
                        ids: [toNumber(wcmAccountId), toNumber(val.id)]
                    }
                },
                {
                    id: [toNumber(wcmAccountId), toNumber(val.id)],
                    label: 'Post-view ' + val.label,
                    isSelectable: true,
                    hasChild: false,
                    parentJsonKeyName: 'wcm_conversion_' + wcmAccountId + '_' + val.id,
                    jsonKey: {
                        name: 'wcm_post_view_conversion_' + wcmAccountId + '_' + val.id,
                        type: 'WcmPostViewConversion',
                        subType: 'conversion',
                        ids: [toNumber(wcmAccountId), toNumber(val.id)]
                    }
                },
                {
                    id: [toNumber(wcmAccountId), toNumber(val.id)],
                    label: 'Untracked ' + val.label,
                    isSelectable: true,
                    hasChild: false,
                    parentJsonKeyName: 'wcm_conversion_' + wcmAccountId + '_' + val.id,
                    jsonKey: {
                        name: 'wcm_untracked_conversion_' + wcmAccountId + '_' + val.id,
                        type: 'WcmUntrackedConversion',
                        subType: 'conversion',
                        ids: [toNumber(wcmAccountId), toNumber(val.id)]
                    }
                }
            ]
            _data.push(...wamData)
        }
        return _data.sort((a, b) => a.label.localeCompare(b.label, undefined, { ignorePunctuation: true, numeric: true }))
    },

    parseCampaignData: (data, wcmAccountId) => {
        let _data = [] //data to return
        let wamData = [] //temp. data
        for (const key in data) {
            const val = data[key]
            //-- first build projects (parents)
            const projectData = [
                {
                    id: [toNumber(key), toNumber(wcmAccountId)],
                    label: val.label,
                    isSelectable: true, //for now
                    hasChild: true,
                    parentJsonKeyName: 'wcm_click_' + wcmAccountId,
                    jsonKey: {
                        name: 'wcm_click_' + key + '_' + wcmAccountId,
                        type: 'WcmClick',
                        subType: 'project',
                        ids: [toNumber(key), toNumber(wcmAccountId)]
                    }
                },
                {
                    id: [toNumber(key), toNumber(wcmAccountId)],
                    label: val.label,
                    isSelectable: true, //for now
                    hasChild: true,
                    parentJsonKeyName: 'wcm_impression_' + wcmAccountId,
                    jsonKey: {
                        name: 'wcm_impression_' + key + '_' + wcmAccountId,
                        type: 'WcmImpression',
                        subType: 'project',
                        ids: [toNumber(key), toNumber(wcmAccountId)]
                    }
                }
            ]

            //-- then build campaigns (children) by loopinh through every channel objects then looping throug channel.campaign objects
            const channelData = []
            //-- channel loop
            const channel = val.channel
            for (const chanKey in channel) {
                const chan = channel[chanKey]
                const campaigns = chan.campaign
                const campaignData = []
                //-- channel.campaign loop
                for (const campKey in campaigns) {
                    const campVal = campaigns[campKey]
                    const insertions = campVal.insertion

                    //-- data for one campaign
                    const campData = [
                        {
                            id: [toNumber(key), toNumber(wcmAccountId), toNumber(campKey)],
                            label: campVal.label,
                            isSelectable: true,
                            hasChild: insertions,
                            parentJsonKeyName: 'wcm_click_' + key + '_' + wcmAccountId,
                            jsonKey: {
                                name: 'wcm_click_' + key + '_' + wcmAccountId + '_' + campKey,
                                type: 'WcmClick',
                                subType: 'project_campaign',
                                ids: [toNumber(key), toNumber(wcmAccountId), toNumber(campKey)]
                            }
                        },
                        {
                            id: [toNumber(key), toNumber(wcmAccountId), toNumber(campKey)],
                            label: campVal.label,
                            isSelectable: true,
                            hasChild: insertions,
                            parentJsonKeyName: 'wcm_impression_' + key + '_' + wcmAccountId,
                            jsonKey: {
                                name: 'wcm_impression_' + key + '_' + wcmAccountId + '_' + campKey,
                                type: 'WcmImpression',
                                subType: 'project_campaign',
                                ids: [toNumber(key), toNumber(wcmAccountId), toNumber(campKey)]
                            }
                        }
                    ]

                    // insertions for one campaign
                    let insertion = []
                    if (insertions) {
                        for (const [insertionKey, insertionValue] of Object.entries(insertions)) {
                            // add 2 insertions one for the clicked tree the other for the exposed tree
                            insertion = [
                                ...insertion,
                                {
                                    id: [(toNumber(key), toNumber(wcmAccountId), toNumber(campKey), toNumber(insertionKey))],
                                    label: insertionValue.label,
                                    isSelectable: true,
                                    hasChild: false,
                                    parentJsonKeyName: 'wcm_click_' + key + '_' + wcmAccountId + '_' + campKey,
                                    jsonKey: {
                                        name: 'wcm_click_' + key + '_' + wcmAccountId + '_' + campKey + '_' + insertionKey,
                                        type: 'WcmClick',
                                        subType: 'projectCampaign',
                                        ids: [toNumber(key), toNumber(wcmAccountId), toNumber(campKey), toNumber(insertionKey)]
                                    }
                                },
                                {
                                    id: [(toNumber(key), toNumber(wcmAccountId), toNumber(campKey), toNumber(insertionKey))],
                                    label: insertionValue.label,
                                    isSelectable: true,
                                    hasChild: false,
                                    parentJsonKeyName: 'wcm_impression_' + key + '_' + wcmAccountId + '_' + campKey,
                                    jsonKey: {
                                        name: 'wcm_impression_' + key + '_' + wcmAccountId + '_' + campKey + '_' + insertionKey,
                                        type: 'WcmImpression',
                                        subType: 'projectCampaign',
                                        ids: [toNumber(key), toNumber(wcmAccountId), toNumber(campKey), toNumber(insertionKey)]
                                    }
                                }
                            ]
                        }
                    }

                    campaignData.push(...campData, ...insertion)
                }
                channelData.push(...campaignData)
            }
            wamData = [...wamData, ...projectData, ...channelData]
            _data = wamData.sort((a, b) => a.label.localeCompare(b.label, undefined, { ignorePunctuation: true, numeric: true }))
        }
        return _data
    },

    instanciateAll(conversions, campaigns, wcmAccountId) {
        const conversionTypes = [
            { label: 'Post-click ', apiType: 'WcmPostClickConversion' },
            { label: 'Post-event ', apiType: 'WcmPostEventConversion' },
            { label: 'Post-impression ', apiType: 'WcmPostImpressionConversion' },
            { label: 'Post-view ', apiType: 'WcmPostViewConversion' },
            { label: 'Untracked ', apiType: 'WcmUntrackedConversion' }
        ]
        const uniqId = `${wcmAccountId}_root`

        const initials = [
            {
                id: uniqId,
                label: 'Campaigns',
                subCategory: 'Campaigns',
                wcmId: wcmAccountId,
                path: ['MyData', 'Media'],
                selectable: false,
                parentId: null
            },
            {
                id: uniqId,
                label: 'Conversions',
                subCategory: 'Conversions',
                wcmId: wcmAccountId,
                path: ['MyData', 'Media'],
                selectable: false,
                parentId: null
            },
            {
                id: uniqId,
                label: 'Exposed',
                subCategory: 'Campaigns',
                subType: 'Exposed',
                wcmId: wcmAccountId,
                path: ['MyData', 'Media'],
                apiType: 'WcmImpression',
                parentIdsChain: [parseInt(uniqId)],
                parentId: Media.generateCrossId({
                    category: 'Media',
                    id: uniqId,
                    subCategory: 'Campaigns'
                })
            },
            {
                id: uniqId,
                label: 'Clicked',
                subCategory: 'Campaigns',
                subType: 'Clicked',
                wcmId: wcmAccountId,
                path: ['MyData', 'Media'],
                apiType: 'WcmClick',
                parentIdsChain: [parseInt(uniqId)],
                parentId: Media.generateCrossId({
                    category: 'Media',
                    id: uniqId,
                    subCategory: 'Campaigns'
                })
            }
        ]
        const childrenConversionsType = []
        const childrenCampaignsType = []

        conversions.forEach(element => {
            for (const type of conversionTypes) {
                childrenConversionsType.push({
                    id: parseInt(element.id),
                    label: type.label + element.label,
                    subCategory: 'Conversions',
                    displayId: true,
                    path: ['MyData', 'Media'],
                    apiType: type.apiType,
                    parentId: Media.generateCrossId({
                        category: 'Media',
                        id: element.id,
                        subCategory: 'Conversions'
                    }),
                    subType: type.label,
                    wcmId: wcmAccountId
                })
            }
        })

        // creating necesseray instances for campaigns, twice for both exposed and clicked
        for (const [id, campaign] of Object.entries(campaigns)) {
            //adding the campaigns on both clicked and exposed
            childrenCampaignsType.push(
                {
                    id: parseInt(id),
                    label: campaign.label,
                    subCategory: 'Campaigns',
                    subType: 'Exposed',
                    displayId: true,
                    level: 'project',
                    path: ['MyData', 'Media'],
                    parentId: Media.generateCrossId({
                        category: 'Media',
                        id: uniqId,
                        subCategory: 'Campaigns',
                        subType: 'Exposed'
                    }),
                    apiType: 'WcmImpression',
                    wcmId: wcmAccountId,
                    parentIdsChain: [parseInt(id), parseInt(uniqId)]
                },
                {
                    id: parseInt(id),
                    label: campaign.label,
                    subCategory: 'Campaigns',
                    subType: 'Clicked',
                    displayId: true,
                    level: 'project',
                    path: ['MyData', 'Media'],
                    parentId: Media.generateCrossId({
                        category: 'Media',
                        id: uniqId,
                        subCategory: 'Campaigns',
                        subType: 'Clicked'
                    }),
                    apiType: 'WcmClick',
                    wcmId: wcmAccountId,
                    parentIdsChain: [parseInt(id), parseInt(uniqId)]
                }
            )

            // eslint-disable-next-line
            for (const [channelId, channel] of Object.entries(campaign.channel)) {
                //skipping the channel level and adding all campaigns flatten without hierarchy

                for (const [subCampaignId, subCampaign] of Object.entries(channel.campaign)) {
                    // adding the campaigns
                    childrenCampaignsType.push(
                        {
                            id: parseInt(subCampaignId),
                            label: subCampaign.label,
                            subCategory: 'Campaigns',
                            subType: 'Exposed',
                            displayId: true,
                            level: 'campaign',
                            path: ['MyData', 'Media'],
                            parentId: Media.generateCrossId({
                                category: 'Media',
                                id: id,
                                subCategory: 'Campaigns',
                                subType: 'Exposed',
                                level: 'project'
                            }),
                            apiType: 'WcmImpression',
                            wcmId: wcmAccountId,
                            parentIdsChain: [parseInt(id), parseInt(uniqId), parseInt(subCampaignId)]
                        },
                        {
                            id: parseInt(subCampaignId),
                            label: subCampaign.label,
                            subCategory: 'Campaigns',
                            subType: 'Clicked',
                            displayId: true,
                            level: 'campaign',
                            path: ['MyData', 'Media'],
                            parentId: Media.generateCrossId({
                                category: 'Media',
                                id: id,
                                subCategory: 'Campaigns',
                                subType: 'Clicked',
                                level: 'project'
                            }),
                            apiType: 'WcmClick',
                            wcmId: wcmAccountId,
                            parentIdsChain: [parseInt(id), parseInt(uniqId), parseInt(subCampaignId)]
                        }
                    )

                    if (subCampaign.insertion) {
                        for (const [insertionId, insertion] of Object.entries(subCampaign.insertion)) {
                            childrenCampaignsType.push(
                                {
                                    id: parseInt(insertionId),
                                    label: insertion.label,
                                    subCategory: 'Campaigns',
                                    subType: 'Exposed',
                                    displayId: true,
                                    level: 'insertion',
                                    path: ['MyData', 'Media'],
                                    parentId: Media.generateCrossId({
                                        category: 'Media',
                                        id: subCampaignId,
                                        subCategory: 'Campaigns',
                                        subType: 'Exposed',
                                        level: 'campaign'
                                    }),
                                    apiType: 'WcmImpression',
                                    wcmId: wcmAccountId,
                                    parentIdsChain: [parseInt(id), parseInt(uniqId), parseInt(subCampaignId), parseInt(insertionId)]
                                },
                                {
                                    id: parseInt(insertionId),
                                    label: insertion.label,
                                    subCategory: 'Campaigns',
                                    subType: 'Clicked',
                                    displayId: true,
                                    level: 'insertion',
                                    path: ['MyData', 'Media'],
                                    parentId: Media.generateCrossId({
                                        category: 'Media',
                                        id: subCampaignId,
                                        subCategory: 'Campaigns',
                                        subType: 'Clicked',
                                        level: 'campaign'
                                    }),
                                    apiType: 'WcmClick',
                                    wcmId: wcmAccountId,
                                    parentIdsChain: [parseInt(id), parseInt(uniqId), parseInt(subCampaignId), parseInt(insertionId)]
                                }
                            )
                        }
                    }
                }
            }
        }

        return Media.createAll([
            ...initials,
            ...conversions.map(conversion => ({
                id: conversion.id,
                label: conversion.label,
                subCategory: 'Conversions',
                displayId: true,
                path: ['MyData', 'Media'],
                apiType: 'WcmConversion',
                parentId: Media.generateCrossId({
                    category: 'Media',
                    id: uniqId,
                    subCategory: 'Conversions'
                }),
                wcmId: wcmAccountId
            })),
            ...childrenConversionsType,
            ...childrenCampaignsType
        ])
    }
}
